/*
 * @Date: 2025-05-07 00:31:39
 * @Author: fangruiyi
 * @LastEditors: fangruiyi
 * @Description:
 */
import type { RouteLocationNormalizedGeneric } from 'vue-router'

import type { RouteMeta } from '@vben-core/typings'

export const createPageKey = (
  route:
    | RouteLocationNormalizedGeneric
    | {
        fullPath: string
        meta: RouteMeta
        name: string | symbol | undefined
        path: string
      },
) => {
  const { pageKey } = route.meta
  const { name, path, fullPath } = route
  if (!pageKey) {
    return fullPath
  }
  return typeof pageKey === 'function'
    ? pageKey({
        name,
        path,
        fullPath,
      })
    : pageKey
}
